import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../Utils/axiosConfig";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { LoginFormTypes } from "../../../Components/Authentication/LoginForm/LoginForm";
import { setStep } from "./authSlice";
import { LoginSteps } from "../../../Constants/loginSteps";
import { setDuration, setUsername } from "./otpSlice";
import { alert } from "../../../Utils/toast";
import { setRecentlyCreated } from "./referralCode";

export type GetOtpCodeLoadAction = {
  type: string;
  payload: LoginFormTypes;
};

export type GetOtpCodeData = {
  data: { message: string; user_recently_created: boolean };
};

const GetOtpCode = new ReduxFetchState<GetOtpCodeData, LoginFormTypes, any>("getOtpCode");

export function* watchGetOtpCode(action: GetOtpCodeLoadAction) {
  const formData = new FormData();
  formData.append("username", action.payload?.username);
  if (action?.payload?.country_code) {
    formData.append("country_code", action?.payload?.country_code);
  }

  try {
    const data: GetOtpCodeData = yield axios({
      headers: { "Content-Type": "multipart/form-data" },
      url: "/api/v1/users/login",
      method: "POST",
      data: formData,
    });

    yield put(GetOtpCode.actions.loadSuccess(data));
    yield put(setStep(LoginSteps.VerifyOtp));
    yield put(setUsername(action.payload?.username));
    yield put(setDuration(120));
    yield put(setRecentlyCreated(data?.data?.user_recently_created));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetOtpCode.actions.loadFailure(e.message));
  }
}

export function* getOtpCodeSagas() {
  yield takeEvery(GetOtpCode.actionTypes.load, watchGetOtpCode);
}

export function useGetOtpCode() {
  const { loading, data, ...getOtpCodeState } = useAppSelector((state) => state.getOtpCode);
  const dispatch = useAppDispatch();

  const dispatchGetOtpCode = useCallback(
    (data: LoginFormTypes) => {
      dispatch(GetOtpCode.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...getOtpCodeState,
    dispatchGetOtpCode,
    getOtpCodeLoading: loading,
    getOtpCodeData: data,
  };
}

export const {
  actionTypes: getOtpCodeActionsTypes,
  actions: getOtpCodeActions,
  reducer: getOtpCodeReducer,
} = GetOtpCode;
